import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white_10}`,
    padding: theme.spacing(6, 8),
    marginBottom: theme.spacing(2),
    width: '100%',
    flexGrow: 1
  },
  addLabel: {
    marginLeft: theme.spacing(2),
    alignSelf: 'flex-start',
    alignContent: 'flex-start',
    color: theme.colors.header__label_primary,
    width: '100%'
  },
  buttonContainer: {
    padding: theme.spacing(2),
    justifyContent: 'flex-end'
  }
});

export default makeStyles(styles);
